import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
  const userName = ref('')
  const userLevel = ref(0)
  const isLoggedIn = ref(false)
  const sessionId = ref('')

  const setUserInfo = (name: string, level: number, session: string) => {
    userName.value = name
    userLevel.value = level
    sessionId.value = session
    isLoggedIn.value = true
  }

  const clearUserInfo = () => {
    userName.value = ''
    userLevel.value = 0
    sessionId.value = ''
    isLoggedIn.value = false
  }

  return {
    userName,
    userLevel,
    isLoggedIn,
    sessionId,
    setUserInfo,
    clearUserInfo
  }
})
